<template>
  <div class="complete_ticket">
    <div class="complete_filedetail">
      <img src="../assets/images/zip.svg" alt="file type" />
      <p class="complete_filename">{{fileInfo.name}}</p>
      <p class="complete_filesize">{{fileInfo.size}}MB</p>
      <p class="complete_title">UPLOAD DATE</p>
      <p class="complete_content">{{fileInfo.date}}</p>
    </div>

    <div class="complete_upDetail">
      <dl class="complete_urlpw">
        <dt class="complete_title" @click="copyDownloadURL">DOWNLOAD URL&#58;</dt>
        <dd id="download_url" class="complete_content">{{fileInfo.download_url}}</dd>
        <dt class="complete_title complete_pw" @click="copyDownloadPassword">PASSWORD&#58;</dt>
        <dd id="download_password" class="complete_content">{{fileInfo.download_password}}</dd>
      </dl>
      <ul class="complete_duration">
        <li>
          <p class="complete_title">PERIOD&#58;</p>
          <p class="complete_content">{{fileInfo.download_expires}} days</p>
        </li>
        <li>
          <p class="complete_title">NUMBER OF TIMES&#58;</p>
          <p class="complete_content">{{fileInfo.download_times}} times</p>
        </li>
        <li>
          <div class="popup" v-if="popupBox">
            <div class="popup_checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>uKHbFJ5c
              </div>
            </div>
            <p class="popup_text" id="myPopup">COPY COMPLETE!</p>
          </div>
          <!-- <a href="#" class="copyBtn" @click="popupBox = !popupBox">COPY ALL</a> -->
        </li>
      </ul>
      <div class="popup popup_dld" v-if="popupBox_dld">
        <div class="popup_checkmark">
          <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
          </div>
        </div>
        <p class="popup_text" id="myPopup">COPY COMPLETE!</p>
      </div>
      <div class="popup popup_pw" v-if="popupBox_pw">
        <div class="popup_checkmark">
          <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
          </div>
        </div>
        <p class="popup_text" id="myPopup">COPY COMPLETE!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: function() {
    return {
      popupBox: false,
      popupBox_pw: false,
      popupBox_dld: false
    };
  },
  mounted: function() {

  },
  methods: {
    copyDownloadURL: function(event){
      this.popupBox_dld = !this.popupBox_dld;
      this.execCopy(String(event.target.nextElementSibling.textContent));
    },
    copyDownloadPassword: function(event){
      this.popupBox_pw = !this.popupBox_pw;
      this.execCopy(String(event.target.nextElementSibling.textContent));
    },
    execCopy: function(string){
      // 空div 生成
      var tmp = document.createElement("div");
      // 選択用のタグ生成
      var pre = document.createElement('pre');

      // 親要素のCSSで user-select: none だとコピーできないので書き換える
      pre.style.webkitUserSelect = 'auto';
      pre.style.userSelect = 'auto';

      tmp.appendChild(pre).textContent = string;

      // 要素を画面外へ
      var s = tmp.style;
      s.position = 'fixed';
      s.right = '200%';

      // body に追加
      document.body.appendChild(tmp);
      // 要素を選択
      document.getSelection().selectAllChildren(tmp);

      // クリップボードにコピー
      var result = document.execCommand("copy");

      // 要素削除
      document.body.removeChild(tmp);

      return result;
    }
  },
  computed: {
    ...mapGetters({
      fileInfo: 'getFileInfo'
    })
  }
};
</script>

<style scoped lang="scss"></style>
